import { useEffect, useState } from 'react';
// import DatePicker from 'react-datepicker';
import "react-datepicker/dist/react-datepicker.css";
import Select from 'react-select';
import Swal from "sweetalert2";
import { getApi, postApi } from "../Admin Master/Area Control/Zonemaster/ServicesApi";
import { useLocation, useNavigate } from 'react-router-dom';
import { PiDotsThreeOutlineVerticalFill } from "react-icons/pi";


function Quotation() {

    const parseDDMMYYYY = (str) => {
        if (!str) return null;
        const [day, month, year] = str.split("/");
        return new Date(`${year}-${month}-${day}`);
    };

    const navigate = useNavigate();
    const location = useLocation();
    const [getCustomer, setGetCustomer] = useState([]);
    const [editIndex, setEditIndex] = useState(null);
    const [editInvoice, setEditInvoice] = useState(false);
    const [getQuotation, setGetQuotation] = useState([]);
    const [openRow, setOpenRow] = useState(null);
    const [loading, setLoading] = useState(false);
    const [rowsPerPage, setRowsPerPage] = useState(10);
    const [currentPage, setCurrentPage] = useState(1);
    const [formData, setFormData] = useState({
        QuotationNo: "",
        Client_Code: "",
        amount: 0,
        Branch_Code:""
    });
    useEffect(() => {
        console.log(formData);
    }, [formData])


    const resetAllForm = () => {
        setFormData({
            QuotationNo: "",
            Client_Code: "",
            amount: 0,
            Branch_Code:""
        });
        setEditIndex(null);
        setEditInvoice(false);

    }

    const fetchQuotation = async () => {
        setLoading(true);

        try {
            const response = await getApi("/GetQuotation");

            if (response?.status === 1) {
                setGetQuotation(response.data || []);
            } else {
                setGetQuotation([]);
            }
        } catch (error) {
            console.error("Error fetching quotation:", error);
            setGetQuotation([]);
        } finally {
            setLoading(false);
        }
    };
    const fetchCustomerData = async () => {
        try {
            const user = JSON.parse(localStorage.getItem("Login"));
            const response = await getApi(`/Master/getCustomerdata?Branch_Code=${user?.Branch_Code}&Customer_Code=${user?.Customer_Code}`)
            setGetCustomer(Array.isArray(response.Data) ? response.Data : []);
        } catch (err) {
            console.log(err);
        }
    };

    useEffect(() => {
        fetchCustomerData();
        fetchQuotation();
    }, [])

    useEffect(() => {
            const loginData = JSON.parse(localStorage.getItem("Login"));
    
            console.log("Login Data:", loginData);
    
            const code = loginData?.Customer_Code;
    
            console.log("Customer Code:", code);
            console.log("Customer Data Array:", getCustomer);
    
            if (code && getCustomer.length > 0) {
    
                const found = getCustomer.find(
                    c => String(c.Customer_Code) === String(code)
                );
    
                console.log("Found customer data:", found);
    
                if (found) {
                    setFormData((prev) => ({
                        ...prev,
                        Client_Code: code,
                        Branch_Code: found.Branch_Code
                    }));
                }
            }
        }, [getCustomer]);
    
         useEffect(() => {
          
    
            const code = formData?.Client_Code;
            if (code && getCustomer.length > 0) {
    
                const found = getCustomer.find(
                    c => String(c.Customer_Code) === String(code)
                );
    
                console.log("Found customer data:", found);
    
                if (found) {
                    setFormData((prev) => ({
                        ...prev,
                        Branch_Code: found.Branch_Code
                    }));
                }
            }
        }, [formData.Client_Code]);

    const handleSave = async (e) => {
    e.preventDefault();

    if (!formData.Client_Code) {
        return Swal.fire({
            icon: "warning",
            title: "Missing Field",
            text: "Please select Customer.",
        });
    }
     if (!formData.amount) {
        return Swal.fire({
            icon: "warning",
            title: "Missing Field",
            text: "Amount is required.",
        });
    }

    try {
        const payload = {
            CustomerCode: formData.Client_Code,
            LocationCode: formData.Branch_Code,
            Description1: formData.Description1 || "",
            Amount: Number(formData.amount || 0),
        };

        console.log(payload);

        const response = await postApi("/AddQuotation", payload);

        if (response.status === 1) {
            Swal.fire({
                icon: "success",
                title: "Success",
                text: response.message,
            });

            resetAllForm();
            fetchQuotation();
        } else {
            Swal.fire({
                icon: "error",
                title: "Failed",
                text: response.message,
            });
        }
    } catch (err) {
        console.error(err);

        Swal.fire({
            icon: "error",
            title: "Error",
            text: err.message,
        });
    }
};

const handleUpdate = async (e) => {
    e.preventDefault();

    if (!formData.QuotationNo) {
        return Swal.fire({
            icon: "warning",
            title: "Missing Field",
            text: "Quotation No is required.",
        });
    }

    if (!formData.Client_Code) {
        return Swal.fire({
            icon: "warning",
            title: "Missing Field",
            text: "Please select Customer.",
        });
    }
     if (!formData.amount) {
        return Swal.fire({
            icon: "warning",
            title: "Missing Field",
            text: "Amount is required.",
        });
    }


    try {
        const payload = {
            QuotationNo: formData.QuotationNo,
            CustomerCode: formData.Client_Code,
            LocationCode: formData.Branch_Code,
            Amount: Number(formData.amount || 0),
        };

        console.log(payload);

        const response = await postApi("/UpdateQuotation", payload);

        if (response.status === 1) {
            Swal.fire({
                icon: "success",
                title: "Updated",
                text: response.message,
            });

            resetAllForm();
            fetchQuotation();
        } else {
            Swal.fire({
                icon: "error",
                title: "Failed",
                text: response.message,
            });
        }
    } catch (err) {
        console.error(err);

        Swal.fire({
            icon: "error",
            title: "Error",
            text: err.message,
        });
    }
};

    const handleDelete = async (quotationNo) => {
        const result = await Swal.fire({
            title: "Are you sure?",
            text: "You won't be able to revert this!",
            icon: "warning",
            showCancelButton: true,
            confirmButtonColor: "#d33",
            cancelButtonColor: "#3085d6",
            confirmButtonText: "Yes, delete it!",
        });

        if (!result.isConfirmed) return;

        try {
            const response = await postApi(
                `/DeleteQuotation?QuotationNo=${encodeURIComponent(quotationNo)}`
            );

            if (response?.status === 1) {
                await Swal.fire({
                    icon: "success",
                    title: "Deleted!",
                    text: response.message,
                });
                fetchQuotation();
                
            } else {
                Swal.fire({
                    icon: "error",
                    title: "Error",
                    text: response.message,
                });
            }
        } catch (error) {
            console.error(error);
            Swal.fire({
                icon: "error",
                title: "Error",
                text: "Failed to delete quotation.",
            });
        }
    };

    const indexOfLastRow = currentPage * rowsPerPage;
    const indexOfFirstRow = indexOfLastRow - rowsPerPage;
    const currentRows = getQuotation.slice(indexOfFirstRow, indexOfLastRow);
    const totalPages = Math.ceil(getQuotation.length / rowsPerPage);

    const handlePreviousPage = () => {
        if (currentPage > 1) setCurrentPage(currentPage - 1);
    };

    const handleNextPage = () => {
        if (currentPage < totalPages) setCurrentPage(currentPage + 1);
    };

    const handleOpenInvoicePrint = (qNo,link) => {
        navigate(link, { state: { quoNo: qNo, from: location.pathname, tab: "Quotation" } })
    };
    return (
        <>


            <div className="body">
                <div className="container1">
                    <form >
                        <div className="fields2">

                            <div className="input-field1">
                                <label>Customer Name</label>
                                <Select
                                    className="blue-selectbooking"
                                    classNamePrefix="blue-selectbooking"
                                    options={getCustomer
                                        .map(cust => ({
                                            label: cust.Customer_Name,
                                            value: cust.Customer_Code,
                                        }))
                                    }
                                    value={
                                        formData.Client_Code
                                            ? {
                                                value: formData.Client_Code,
                                                label: getCustomer.find(
                                                    cust => cust.Customer_Code === formData.Client_Code
                                                )?.Customer_Name || ""
                                            }
                                            : null
                                    }
                                    onChange={(selectedOption) => {
                                        setFormData({
                                            ...formData,
                                            Client_Code: selectedOption ? selectedOption.value : ""
                                        });
                                    }}
                                    placeholder="Select Customer"
                                    isSearchable
                                    menuPortalTarget={document.body}
                                    styles={{
                                        menuPortal: base => ({ ...base, zIndex: 9999 })
                                    }}
                                />
                            </div>


                            {/* Invoice Date */}
                            <div className="input-field3">
                                <label>Amount</label>
                                <input type="tel" className='input' placeholder='Amount' value={formData.amount} onChange={(e) => setFormData({ ...formData, amount: e.target.value })} />
                            </div>









                            <div className="bottom-buttons" style={{ marginLeft: "10px", marginTop: "23px" }}>
                                {!editInvoice ? <button className='ok-btn' onClick={handleSave}>Save</button> :
                                    <button className='ok-btn' type='button' onClick={handleUpdate}>Update</button>}
                                <button className='ok-btn' type='button' onClick={resetAllForm}>Cancel</button>
                            </div>


                        </div>

                    </form>


                    <div className='table-container' style={{ margin: "0px" }}>
                        <table className='table table-bordered table-sm' style={{ whiteSpace: "nowrap" }}>
                            <thead className='table-sm'>
                                <tr>
                                    <th className="w-60">Actions</th>
                                    <th className="w-60">Sr.No</th>
                                    <th className="w-100">Quotation No</th>
                                    <th className="w-100">Quotation Date</th>
                                    <th>Customer Name</th>
                                    <th>Amount</th>
                                    <th>Desktop</th>
                                    <th>Mobile</th>
                                </tr>
                            </thead>
                            <tbody>
                                {currentRows.map((row, index) => (
                                    <tr key={index} style={{ fontSize: "12px", position: "relative" }}>
                                        <td className="w-60"><PiDotsThreeOutlineVerticalFill
                                            style={{ fontSize: "20px", cursor: "pointer" }}
                                            onClick={() =>
                                                setOpenRow(openRow === index ? null : index) // toggle only this row
                                            }
                                        />

                                            {openRow === index && (
                                                <div
                                                    style={{
                                                        display: "flex",
                                                        justifyContent: "center",
                                                        flexDirection: "row",
                                                        position: "absolute",
                                                        alignItems: "center",
                                                        left: "70px",
                                                        top: "1px",
                                                        borderRadius: "10px",
                                                        backgroundColor: "white",
                                                        zIndex: "999999",
                                                        height: "24px",
                                                        width: "100px",
                                                        padding: "10px",
                                                    }}
                                                >
                                                    
                                                     <button onClick={() => {
                                                        setOpenRow(null);
                                                        setEditInvoice(true);
                                                        setFormData({
                                                            Branch_Code:row?.LocationCode,
                                                            Client_Code:row?.CustomerCode,
                                                            amount:row?.Amount,
                                                            QuotationNo:row?.QuotationNo,
                                                        })
                                                    }
                                                    } className='edit-btn'>
                                                        <i className='bi bi-pen'></i>
                                                    </button>
                                                    <button onClick={() => {
                                                        setOpenRow(null);
                                                        handleDelete(row.QuotationNo)
                                                    }
                                                    } className='edit-btn'>
                                                        <i className='bi bi-trash' ></i>
                                                    </button>
                                                </div>
                                            )}</td>
                                        <td className="w-60">{index + 1}</td>
                                        <td>{row.QuotationNo}</td>
                                        <td>{row.QuotationDate}</td>
                                        <td>{row.CustomerName}</td>
                                        <td>{row.Amount}</td>
                                        <td>
                                            <button className='edit-btn' onClick={() => handleOpenInvoicePrint(row?.QuotationNo,"/quotationpdf")}>
                                                        <i className='bi bi-file-earmark-pdf-fill' ></i>
                                                    </button>
                                        </td>
                                        <td>
                                            <button className='edit-btn' onClick={() => handleOpenInvoicePrint(row?.QuotationNo,"/quotationmobpdf")}>
                                                        <i className='bi bi-file-earmark-pdf-fill' ></i>
                                                    </button>
                                        </td>

                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    </div >


                    <div className="row" style={{ whiteSpace: "nowrap" }}>
                        <div className="pagination col-12 col-md-6 d-flex justify-content-center align-items-center mb-2 mb-md-0">
                            <button className="ok-btn" onClick={handlePreviousPage} disabled={currentPage === 1}>
                                {'<'}
                            </button>
                            <span style={{ color: "#333", padding: "5px" }}>
                                Page {currentPage} of {totalPages}
                            </span>
                            <button className="ok-btn" onClick={handleNextPage} disabled={currentPage === totalPages}>
                                {'>'}
                            </button>
                        </div>

                        <div className="rows-per-page col-12 col-md-6 d-flex justify-content-center justify-content-md-end align-items-center">
                            <span htmlFor="rowsPerPage" className="me-2">Rows per page: </span>
                            <select
                                id="rowsPerPage"
                                value={rowsPerPage}
                                onChange={(e) => {
                                    setRowsPerPage(Number(e.target.value));
                                    setCurrentPage(1);
                                }}

                                style={{ height: "40px", width: "50px", border: "1.5px solid #002357" }}
                            >
                                <option value={5}>5</option>
                                <option value={10}>10</option>
                                <option value={25}>25</option>
                                <option value={50}>50</option>
                                <option value={100}>100</option>
                                <option value={200}>200</option>
                                <option value={500}>500</option>
                            </select>
                        </div>
                    </div>







                </div>
            </div>

        </>
    )
}

export default Quotation;